import PropTypes from 'prop-types'
import React from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

import DynamicImage from 'components/DynamicImage'

import { Window, WindowControls, WindowHeader, Frame, ImageBox } from './styles'

/**
 * Component to print some images in the browser's window
 *
 * @param {object} props - Properties of the component
 * @returns {function} function - FrameBrowser
 */
const FrameBrowser = props => {
  const { src, children, className, colorTheme, alt } = props

  return (
    <div className={className}>
      <Window {...{ colorTheme }}>
        <WindowHeader>
          <WindowControls />
          <WindowControls />
          <WindowControls />
        </WindowHeader>
        <Frame>
          <TransitionGroup component={null}>
            <CSSTransition
              appear={true}
              timeout={{ enter: 400, exit: 700 }}
              key={src}
              classNames="frame-browser__image-"
            >
              {state => (
                <ImageBox {...{ state }}>
                  <DynamicImage
                    image={src}
                    alt={alt}
                    imageSizes={{
                      xs: 670,
                      md: 840,
                    }}
                  />
                </ImageBox>
              )}
            </CSSTransition>
          </TransitionGroup>
        </Frame>
      </Window>
      {children}
    </div>
  )
}

FrameBrowser.propTypes = {
  /** Alternate text for image */
  alt: PropTypes.string.isRequired,

  /** Path to image to show it inside frame */
  src: PropTypes.string.isRequired,

  /** You can pass here some node to render it after frame */
  children: PropTypes.node,

  /** Class names for wrapper */
  className: PropTypes.string,

  /** Color theme for window header */
  colorTheme: PropTypes.oneOf(['dark', 'light']),
}

FrameBrowser.defaultProps = {
  className: '',
  children: null,
  colorTheme: 'light',
}

export default FrameBrowser
